import { ReactNode, useEffect } from 'react';

import './modal.scss';

interface ModalInterface {
    children: ReactNode;
    open: boolean;
    onClose: () => void;
    className?: string;
    darkBackground?: boolean;
    content?: string;
}

const Modal = (props: ModalInterface) => {
    const {
        children,
        onClose,
        open = true,
        className,
        content,
        darkBackground = false,
    } = props;

    useEffect(() => {
        open
            ? document.body.classList.add('a-modal--open')
            : document.body.classList.remove('a-modal--open');
    }, [open]);

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        return () => {
            document.documentElement.style.overflowY = 'scroll';
        };
    }, []);

    return (
        <>
            {open && (
                <div
                    className={`a-modal ${
                        darkBackground ? 'a-modal-dark' : ''
                    } ${content}`}
                    role="dialog"
                >
                    <div
                        className={`a-modal__wrapper ${className}`}
                        onClick={(e) => {
                            e.currentTarget === e.target && onClose();
                        }}
                    >
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};

export default Modal;
